<div class="observe-section mt-0">
  <h1 class="section-title-observe mb-2">{{ 'EVALUATION.STATISTICAL_EVALUATION' | translate }}</h1>
  <p class="col-sm-12 col-md-9 pb-3 static-card-desc pl-0">{{ 'EVALUATION.HELP_TEXT.FILTER_FUNCTION_OBSERVE' | translate }}
  </p>
  <div class="row col p-0">
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'overallCompliance'})">
        <h1 class="section-title menuLink">{{'EVALUATION.TOTAL.RATE_OVERALL_COMPLIANCE' | translate }}</h1>
        <p>
          {{'EVALUATION.HELP_TEXT.RATE_OVERALL_COMPLIANCE' | translate}}
        </p>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'fiveMoments'})">
        <h1 class="section-title menuLink">{{ translationKeys.Dashboard.FiveMoments | translate }}</h1>
        <p>
          {{'EVALUATION.HELP_TEXT.HYGIENE_COMPLIANCE_FIVE_MOMENTS' | translate}}
        </p>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'StatisticsBeforeAsepticProcedures'})">
        <h1 class="section-title menuLink">{{ 'EVALUATION.STATISTICS_ASEPT' | translate }}</h1>
        <p>{{ 'EVALUATION.HELP_TEXT.HYGIENE_COMPLIANCE_BEFORE_ASEPTIC_PROCEDURES' | translate }}
        </p>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'individualOverview'})">
        <h1 class="section-title menuLink">{{'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_2' | translate }}</h1>
        <p>{{ 'EVALUATION.HELP_TEXT.OVERVIEW_2' | translate }}
        </p>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'comments'})">
        <h1 class="section-title menuLink">{{ 'EVALUATION.COMMENTS' | translate }}</h1>
        <p>{{ 'EVALUATION.HELP_TEXT.GRAPH' | translate }}
        </p>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'quota'})">
        <h1 class="section-title menuLink">{{ translationKeys.Configure.Quota | translate }}</h1>
        <p>{{ 'EVALUATION.HELP_TEXT.QUOTA' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
